import { createContext } from 'react';
export const EnrichableObjectTypesContext = /*#__PURE__*/createContext(undefined);